
import { Button } from "@/components/ui/button";
import { Filter, BarChart } from "lucide-react";
import { Category } from '@/hooks/useCategories';

interface CategoryFiltersProps {
  categories: Category[];
  selectedCategory: string | null;
  setSelectedCategory: (category: string | null) => void;
}

const CategoryFilters = ({ 
  categories, 
  selectedCategory, 
  setSelectedCategory 
}: CategoryFiltersProps) => {
  return (
    <div className="mb-8">
      <div className="flex items-center gap-3 mb-4">
        <div className="flex items-center gap-2 text-foreground/80">
          <Filter size={20} className="text-primary" />
          <span className="text-base font-medium">Filter by Category</span>
        </div>
      </div>
      
      <div className="flex flex-wrap gap-3">
        <Button 
          key="all"
          variant={!selectedCategory ? "default" : "secondary"}
          size="default"
          className={!selectedCategory 
            ? "bg-primary hover:bg-primary/90 text-primary-foreground shadow-md flex items-center gap-2 px-4 py-2 h-auto" 
            : "bg-secondary/50 hover:bg-secondary/80 text-secondary-foreground border border-border/50 flex items-center gap-2 px-4 py-2 h-auto"}
          onClick={() => setSelectedCategory(null)}
        >
          <BarChart size={18} />
          <span className="font-medium">All Categories</span>
        </Button>
        
        {categories.map(category => {
          const IconComponent = category.icon || BarChart;
          const isSelected = selectedCategory === category.id;
          return (
            <Button 
              key={category.id}
              variant={isSelected ? "default" : "secondary"}
              size="default"
              className={isSelected 
                ? "bg-primary hover:bg-primary/90 text-primary-foreground shadow-md flex items-center gap-2 px-4 py-2 h-auto" 
                : "bg-secondary/50 hover:bg-secondary/80 text-secondary-foreground border border-border/50 flex items-center gap-2 px-4 py-2 h-auto"}
              onClick={() => setSelectedCategory(category.id)}
            >
              <IconComponent size={18} />
              <span className="font-medium">{category.name}</span>
            </Button>
          )
        })}
      </div>
    </div>
  );
};

export default CategoryFilters;
